import { exportDataTableExcel } from '../lanz-ui';

export async function exportGridPdf({ rows, columns, fileName = 'relatorio', title = 'Relatório' }) {
  const [{ jsPDF }, autoTableMod] = await Promise.all([
    import('jspdf'),
    import('jspdf-autotable'),
  ]);
  const autoTable = autoTableMod.default || autoTableMod;

  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  doc.setFontSize(14);
  doc.text(title, 40, 36);

  const headers = (columns || []).map((c) => c.header || c.field);
  const body = (rows || []).map((row) =>
    (columns || []).map((c) => {
      if (typeof c.exportValue === 'function') return String(c.exportValue(row) ?? '');
      const v = row?.[c.field];
      if (v == null) return '';
      if (typeof v === 'object') return JSON.stringify(v);
      return String(v);
    })
  );

  autoTable(doc, {
    head: [headers],
    body,
    startY: 48,
    styles: { fontSize: 8, cellPadding: 4 },
    headStyles: { fillColor: [0, 36, 120], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [248, 249, 250] },
  });

  const dia = new Date().toISOString().split('T')[0];
  doc.save(`${fileName}_${dia}.pdf`);
}

export function exportGridExcel({ rows, columns, fileName = 'relatorio', sheetName = 'Dados' }) {
  const cols = (columns || []).map((c) => ({
    field: c.field,
    header: c.header || c.field,
    value: typeof c.exportValue === 'function' ? (row) => c.exportValue(row) : undefined,
  }));
  exportDataTableExcel({
    data: rows,
    columns: cols,
    fileName,
    sheetName,
  });
}
